import useOverrides from '@/composables/useOverrides'
import type { Product, ComplianceCompatibility, ComplianceOverrides } from '@/types/products.interfaces'

/**
 * Functions responsible for enriching products with compliance information
 * Centralizes compliance-related logic and provides a clean separation of concerns
 */

// Get overrides composable instance for use in functions
const overridesComposable = useOverrides()

/**
 * Enrich a product with compliance information
 * @param product - The product to enrich
 * @returns The product with enriched compliance data
 */
export function enrichProductWithCompliance(product: Product): Product {
  return {
    ...product,
    compliance: {
      compatibility: product.compliance?.compatibility || {} as ComplianceCompatibility,
      overrides: product.compliance?.overrides || {} as ComplianceOverrides,
      ...product.compliance,
      phpCompatibilityWithShop: overridesComposable.productPhpCompatibility(product),
      compatibilityTag: overridesComposable.getProductCompatibilityTag(product)
    }
  }
}

/**
 * Enhance product overrides with shop overrides
 * @param product - The product to enhance
 * @returns the product with enhanced overrides
 */
export function enrichProductOverridesWithShopOverrides(product: Product): Product {
  return overridesComposable.enhanceProductOverrides(product)
}
